import axios from 'axios'

const httpClient = axios.create({
  baseURL: 'https://9kpkpn1r2h.execute-api.eu-central-1.amazonaws.com/default'
})

class AmioSlackService {
  async createNewLead(email, phoneNumber = null, message = null, channel = 'new_lead') {
    const result = await httpClient.post('/contact-us-to-slack', {
      email,
      phone_number: phoneNumber,
      message,
      channel
    })

    return result ? result.data : null
  }
}

export default new AmioSlackService()
